export interface ThaiAddress {
  p: string; // Province
  d: string; // District (Amphoe)
  s: string; // Subdistrict (Tambon)
  z: string; // Zipcode
}

export const THAI_ADDRESSES_DATABASE: ThaiAddress[] = [
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "พระบรมมหาราชวัง", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "วังบูรพาภิรมย์", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "วัดราชบพิธ", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "สำราญราษฎร์", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "ศาลเจ้าพ่อเสือ", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "เสาชิงช้า", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "บวรนิเวศ", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "ตลาดยอด", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "ชนะสงคราม", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "บ้านพานถม", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "บางขุนพรหม", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "พระนคร", s: "วัดสามพระยา", z: "10200" },
  { p: "กรุงเทพมหานคร", d: "ดุสิต", s: "ดุสิต", z: "10300" },
  { p: "กรุงเทพมหานคร", d: "ดุสิต", s: "วชิรพยาบาล", z: "10300" },
  { p: "กรุงเทพมหานคร", d: "ดุสิต", s: "สวนจิตรลดา", z: "10300" },
  { p: "กรุงเทพมหานคร", d: "ดุสิต", s: "สี่แยกมหานาค", z: "10300" },
  { p: "กรุงเทพมหานคร", d: "ดุสิต", s: "ถนนนครไชยศรี", z: "10300" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "กระทุ่มราย", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "หนองจอก", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "คลองสิบ", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "คลองสิบสอง", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "โคกแฝด", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "คู้ฝั่งเหนือ", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "ลำผักชี", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "หนองจอก", s: "ลำต้อยติ่ง", z: "10530" },
  { p: "กรุงเทพมหานคร", d: "บางรัก", s: "มหาพฤฒาราม", z: "10500" },
  { p: "กรุงเทพมหานคร", d: "บางรัก", s: "สีลม", z: "10500" },
  { p: "กรุงเทพมหานคร", d: "บางรัก", s: "สุริยวงศ์", z: "10500" },
  { p: "กรุงเทพมหานคร", d: "บางรัก", s: "บางรัก", z: "10500" },
  { p: "กรุงเทพมหานคร", d: "บางรัก", s: "สี่พระยา", z: "10500" },
  { p: "กรุงเทพมหานคร", d: "บางเขน", s: "อนุสาวรีย์", z: "10220" },
  { p: "กรุงเทพมหานคร", d: "บางเขน", s: "ท่าแร้ง", z: "10220" },
  { p: "กรุงเทพมหานคร", d: "บางกะปิ", s: "คลองจั่น", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "บางกะปิ", s: "หัวหมาก", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "ปทุมวัน", s: "รองเมือง", z: "10330" },
  { p: "กรุงเทพมหานคร", d: "ปทุมวัน", s: "วังใหม่", z: "10330" },
  { p: "กรุงเทพมหานคร", d: "ปทุมวัน", s: "ปทุมวัน", z: "10330" },
  { p: "กรุงเทพมหานคร", d: "ปทุมวัน", s: "ลุมพินี", z: "10330" },
  { p: "กรุงเทพมหานคร", d: "ป้อมปราบศัตรูพ่าย", s: "ป้อมปราบ", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "ป้อมปราบศัตรูพ่าย", s: "วัดเทพศิรินทร์", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "ป้อมปราบศัตรูพ่าย", s: "คลองมหานาค", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "ป้อมปราบศัตรูพ่าย", s: "บ้านบาตร", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "ป้อมปราบศัตรูพ่าย", s: "วัดโสมนัส", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "พระโขนง", s: "บางจาก", z: "10260" },
  { p: "กรุงเทพมหานคร", d: "มีนบุรี", s: "มีนบุรี", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "มีนบุรี", s: "แสนแสบ", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "ลาดกระบัง", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "คลองสองต้นนุ่น", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "คลองสามประเวศ", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "ลำปลาทิว", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "ทับยาว", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ลาดกระบัง", s: "ขุมทอง", z: "10520" },
  { p: "กรุงเทพมหานคร", d: "ยานนาวา", s: "ช่องนนทรี", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "ยานนาวา", s: "บางโพงพาง", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "สัมพันธวงศ์", s: "จักรวรรดิ", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "สัมพันธวงศ์", s: "สัมพันธวงศ์", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "สัมพันธวงศ์", s: "ตลาดน้อย", z: "10100" },
  { p: "กรุงเทพมหานคร", d: "พญาไท", s: "สามเสนใน", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "วัดกัลยาณ์", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "หิรัญรูจี", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "บางยี่เรือ", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "บุคคโล", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "ตลาดพลู", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "ดาวคะนอง", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ธนบุรี", s: "สำเหร่", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "บางกอกใหญ่", s: "วัดอรุณ", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "บางกอกใหญ่", s: "วัดท่าพระ", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ห้วยขวาง", s: "ห้วยขวาง", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "ห้วยขวาง", s: "บางกะปิ", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "ห้วยขวาง", s: "สามเสนนอก", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "คลองสาน", s: "สมเด็จเจ้าพระยา", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "คลองสาน", s: "คลองสาน", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "คลองสาน", s: "บางลำภูล่าง", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "คลองสาน", s: "คลองต้นไทร", z: "10600" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "คลองชักพระ", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "ตลิ่งชัน", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "ฉิมพลี", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "บางพรม", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "บางระมาด", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ตลิ่งชัน", s: "บางเชือกหนัง", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "บางกอกน้อย", s: "ศิริราช", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางกอกน้อย", s: "บ้านช่างหล่อ", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางกอกน้อย", s: "บางขุนนนท์", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางกอกน้อย", s: "บางขุนศรี", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางกอกน้อย", s: "อรุณอมรินทร์", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางขุนเทียน", s: "ท่าข้าม", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "บางขุนเทียน", s: "แสมดำ", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "บางหว้า", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "บางด้วน", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "บางจาก", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "บางแวก", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "คลองขวาง", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "ปากคลองภาษีเจริญ", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ภาษีเจริญ", s: "คูหาสวรรค์", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "หนองแขม", s: "หนองแขม", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "หนองแขม", s: "หนองค้างพลู", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "ราษฎร์บูรณะ", s: "ราษฎร์บูรณะ", z: "10140" },
  { p: "กรุงเทพมหานคร", d: "ราษฎร์บูรณะ", s: "บางปะกอก", z: "10140" },
  { p: "กรุงเทพมหานคร", d: "บางพลัด", s: "บางพลัด", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางพลัด", s: "บางอ้อ", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางพลัด", s: "บางบำหรุ", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "บางพลัด", s: "บางยี่ขัน", z: "10700" },
  { p: "กรุงเทพมหานคร", d: "ดินแดง", s: "ดินแดง", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "บึงกุ่ม", s: "คลองกุ่ม", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "บึงกุ่ม", s: "นวมินทร์", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "บึงกุ่ม", s: "นวลจันทร์", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "สาทร", s: "ทุ่งวัดดอน", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "สาทร", s: "ยานนาวา", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "สาทร", s: "ทุ่งมหาเมฆ", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "บางซื่อ", s: "บางซื่อ", z: "10800" },
  { p: "กรุงเทพมหานคร", d: "บางซื่อ", s: "วงศ์สว่าง", z: "10800" },
  { p: "กรุงเทพมหานคร", d: "จตุจักร", s: "ลาดยาว", z: "10900" },
  { p: "กรุงเทพมหานคร", d: "จตุจักร", s: "เสนานิคม", z: "10900" },
  { p: "กรุงเทพมหานคร", d: "จตุจักร", s: "จันทรเกษม", z: "10900" },
  { p: "กรุงเทพมหานคร", d: "จตุจักร", s: "จอมพล", z: "10900" },
  { p: "กรุงเทพมหานคร", d: "จตุจักร", s: "จตุจักร", z: "10900" },
  { p: "กรุงเทพมหานคร", d: "บางคอแหลม", s: "บางคอแหลม", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "บางคอแหลม", s: "วัดพระยาไกร", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "บางคอแหลม", s: "บางโคล่", z: "10120" },
  { p: "กรุงเทพมหานคร", d: "ประเวศ", s: "ประเวศ", z: "10250" },
  { p: "กรุงเทพมหานคร", d: "ประเวศ", s: "หนองบอน", z: "10250" },
  { p: "กรุงเทพมหานคร", d: "ประเวศ", s: "ดอกไม้", z: "10250" },
  { p: "กรุงเทพมหานคร", d: "คลองเตย", s: "คลองเตย", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "คลองเตย", s: "คลองตัน", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "คลองเตย", s: "พระโขนง", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "สวนหลวง", s: "สวนหลวง", z: "10250" },
  { p: "กรุงเทพมหานคร", d: "จอมทอง", s: "บางขุนเทียน", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "จอมทอง", s: "บางค้อ", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "จอมทอง", s: "บางมด", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "จอมทอง", s: "จอมทอง", z: "10150" },
  { p: "กรุงเทพมหานคร", d: "ดอนเมือง", s: "สีกัน", z: "10210" },
  { p: "กรุงเทพมหานคร", d: "ดอนเมือง", s: "ดอนเมือง", z: "10210" },
  { p: "กรุงเทพมหานคร", d: "ดอนเมือง", s: "สนามบิน", z: "10210" },
  { p: "กรุงเทพมหานคร", d: "ราชเทวี", s: "ทุ่งพญาไท", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "ราชเทวี", s: "ถนนพญาไท", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "ราชเทวี", s: "ถนนเพชรบุรี", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "ราชเทวี", s: "มักกะสัน", z: "10400" },
  { p: "กรุงเทพมหานคร", d: "ลาดพร้าว", s: "ลาดพร้าว", z: "10230" },
  { p: "กรุงเทพมหานคร", d: "ลาดพร้าว", s: "จรเข้บัว", z: "10230" },
  { p: "กรุงเทพมหานคร", d: "วัฒนา", s: "คลองเตยเหนือ", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "วัฒนา", s: "คลองตันเหนือ", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "วัฒนา", s: "พระโขนงเหนือ", z: "10110" },
  { p: "กรุงเทพมหานคร", d: "บางแค", s: "บางแค", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "บางแค", s: "บางแคเหนือ", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "บางแค", s: "บางไผ่", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "บางแค", s: "หลักสอง", z: "10160" },
  { p: "กรุงเทพมหานคร", d: "หลักสี่", s: "ทุ่งสองห้อง", z: "10210" },
  { p: "กรุงเทพมหานคร", d: "หลักสี่", s: "ตลาดบางเขน", z: "10210" },
  { p: "กรุงเทพมหานคร", d: "สายไหม", s: "สายไหม", z: "10220" },
  { p: "กรุงเทพมหานคร", d: "สายไหม", s: "ออเงิน", z: "10220" },
  { p: "กรุงเทพมหานคร", d: "สายไหม", s: "คลองถนน", z: "10220" },
  { p: "กรุงเทพมหานคร", d: "คันนายาว", s: "คันนายาว", z: "10230" },
  { p: "กรุงเทพมหานคร", d: "คันนายาว", s: "รามอินทรา", z: "10230" },
  { p: "กรุงเทพมหานคร", d: "สะพานสูง", s: "สะพานสูง", z: "10240" },
  { p: "กรุงเทพมหานคร", d: "วังทองหลาง", s: "วังทองหลาง", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "วังทองหลาง", s: "สะพานสอง", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "วังทองหลาง", s: "คลองเจ้าคุณสิงห์", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "วังทองหลาง", s: "พลับพลา", z: "10310" },
  { p: "กรุงเทพมหานคร", d: "คลองสามวา", s: "สามวาตะวันตก", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "คลองสามวา", s: "สามวาตะวันออก", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "คลองสามวา", s: "บางชัน", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "คลองสามวา", s: "ทรายกองดิน", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "คลองสามวา", s: "ทรายกองดินใต้", z: "10510" },
  { p: "กรุงเทพมหานคร", d: "บางนา", s: "บางนา", z: "10260" },
  { p: "กรุงเทพมหานคร", d: "ทวีวัฒนา", s: "ทวีวัฒนา", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ทวีวัฒนา", s: "ศาลาธรรมสพน์", z: "10170" },
  { p: "กรุงเทพมหานคร", d: "ทุ่งครุ", s: "บางมด", z: "10140" },
  { p: "กรุงเทพมหานคร", d: "ทุ่งครุ", s: "ทุ่งครุ", z: "10140" },
  { p: "กรุงเทพมหานคร", d: "บางบอน", s: "บางบอน", z: "10150" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "ปากน้ำ", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "สำโรงเหนือ", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางเมือง", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "ท้ายบ้าน", z: "10280" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางปูใหม่", z: "10280" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "แพรกษา", z: "10280" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางโปรง", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางปู", z: "10280" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางด้วน", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "บางเมืองใหม่", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "เทพารักษ์", z: "10270" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "ท้ายบ้านใหม่", z: "10280" },
  { p: "สมุทรปราการ", d: "เมืองสมุทรปราการ", s: "แพรกษาใหม่", z: "10280" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "บางบ่อ", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "บ้านระกาศ", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "บางพลีน้อย", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "บางเพรียง", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "คลองด่าน", z: "10550" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "คลองสวน", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "เปร็ง", z: "10560" },
  { p: "สมุทรปราการ", d: "บางบ่อ", s: "คลองนิยมยาตรา", z: "10560" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "บางพลีใหญ่", z: "10540" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "บางแก้ว", z: "10540" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "บางปลา", z: "10540" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "บางโฉลง", z: "10540" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "ราชาเทวะ", z: "10540" },
  { p: "สมุทรปราการ", d: "บางพลี", s: "หนองปรือ", z: "10540" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "ตลาด", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางพึ่ง", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางจาก", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางครุ", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางหญ้าแพรก", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางหัวเสือ", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "สำโรงใต้", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางยอ", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางกะเจ้า", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางน้ำผึ้ง", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางกระสอบ", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "บางกอบัว", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "ทรงคนอง", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "สำโรง", z: "10130" },
  { p: "สมุทรปราการ", d: "พระประแดง", s: "สำโรงกลาง", z: "10130" },
  { p: "สมุทรปราการ", d: "พระสมุทรเจดีย์", s: "นาเกลือ", z: "10290" },
  { p: "สมุทรปราการ", d: "พระสมุทรเจดีย์", s: "บ้านคลองสวน", z: "10290" },
  { p: "สมุทรปราการ", d: "พระสมุทรเจดีย์", s: "แหลมฟ้าผ่า", z: "10290" },
  { p: "สมุทรปราการ", d: "พระสมุทรเจดีย์", s: "ปากคลองบางปลากด", z: "10290" },
  { p: "สมุทรปราการ", d: "พระสมุทรเจดีย์", s: "ในคลองบางปลากด", z: "10290" },
  { p: "สมุทรปราการ", d: "บางเสาธง", s: "บางเสาธง", z: "10540" },
  { p: "สมุทรปราการ", d: "บางเสาธง", s: "ศีรษะจรเข้น้อย", z: "10540" },
  { p: "สมุทรปราการ", d: "บางเสาธง", s: "ศีรษะจรเข้ใหญ่", z: "10540" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "สวนใหญ่", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "ตลาดขวัญ", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางเขน", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางกระสอ", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "ท่าทราย", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางไผ่", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางศรีเมือง", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางกร่าง", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "ไไรม้า", z: "11000" },
  { p: "นนทบุรี", d: "เมืองนนทบุรี", s: "บางรักน้อย", z: "11000" },
  { p: "นนทบุรี", d: "บางกรวย", s: "วัดชลอ", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "บางกรวย", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "บางสีทอง", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "บางขนุน", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "บางขุนกอง", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "บางคูเวียง", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "มหาสวัสดิ์", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "ปลายบาง", z: "11130" },
  { p: "นนทบุรี", d: "บางกรวย", s: "ศาลากลาง", z: "11130" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "บางม่วง", z: "11140" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "บางแม่นาง", z: "11140" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "บางเลน", z: "11140" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "เสาธงหิน", z: "11140" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "บางใหญ่", z: "11140" },
  { p: "นนทบุรี", d: "บางใหญ่", s: "บ้านใหม่", z: "11140" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "โสนลอย", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "บางบัวทอง", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "บางรักใหญ่", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "บางคูรัด", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "ละหาร", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "ลำโพ", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "พิมลราช", z: "11110" },
  { p: "นนทบุรี", d: "บางบัวทอง", s: "บางรักพัฒนา", z: "11110" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "ไทรน้อย", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "ราษฎร์นิยม", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "หนองเพรางาย", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "ไทรใหญ่", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "ขุนศรี", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "คลองขวาง", z: "11150" },
  { p: "นนทบุรี", d: "ไทรน้อย", s: "ทวีวัฒนา", z: "11150" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "ปากเกร็ด", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "บางตลาด", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "บ้านใหม่", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "บางพูด", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "บางตะไนย์", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "คลองพระอุดม", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "ท่าอิฐ", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "เกาะเกร็ด", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "อ้อมเกร็ด", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "คลองข่อย", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "บางพลับ", z: "11120" },
  { p: "นนทบุรี", d: "ปากเกร็ด", s: "คลองเกลือ", z: "11120" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางปรอก", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บ้านใหม่", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บ้านกลาง", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บ้านฉาง", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บ้านกระแชง", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางขะแยง", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางคูวัด", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางหลวง", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางเดื่อ", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางพูด", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางพูน", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "บางกะดี", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "สวนพริกไทย", z: "12000" },
  { p: "ปทุมธานี", d: "เมืองปทุมธานี", s: "หลักหก", z: "12000" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองหนึ่ง", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองสอง", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองสาม", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองสี่", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองห้า", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองหก", z: "12120" },
  { p: "ปทุมธานี", d: "คลองหลวง", s: "คลองเจ็ด", z: "12120" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "ประชาธิปัตย์", z: "12130" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "บึงยี่โถ", z: "12130" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "รังสิต", z: "12110" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "ลำผักกูด", z: "12110" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "บึงสนั่น", z: "12110" },
  { p: "ปทุมธานี", d: "ธัญบุรี", s: "บึงน้ำรักษ์", z: "12110" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "บึงบา", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "บึงบอน", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "บึงกาสาม", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "บึงชำอ้อ", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "หนองสามวัง", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "ศาลาครุ", z: "12170" },
  { p: "ปทุมธานี", d: "หนองเสือ", s: "นพรัตน์", z: "12170" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "ระแหง", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "ลาดหลุมแก้ว", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "คูบางหลวง", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "คูขวาง", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "คลองพระอุดม", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "บ่อเงิน", z: "12140" },
  { p: "ปทุมธานี", d: "ลาดหลุมแก้ว", s: "หน้าไม้", z: "12140" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "คูคต", z: "12130" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "ลาดสวาย", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "บึงคำพร้อย", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "ลำลูกกา", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "บึงทองหลาง", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "ลำไทร", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "บึงคอไห", z: "12150" },
  { p: "ปทุมธานี", d: "ลำลูกกา", s: "พืชอุดม", z: "12150" },
  { p: "ปทุมธานี", d: "สามโคก", s: "บางเตย", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "คลองควาย", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "สามโคก", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "กระแชง", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "บางโพธิ์เหนือ", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "เชียงรากใหญ่", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "บ้านปทุม", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "บ้านงิ้ว", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "เชียงรากน้อย", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "บางกระบือ", z: "12160" },
  { p: "ปทุมธานี", d: "สามโคก", s: "ท้ายเกาะ", z: "12160" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ประตูชัย", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "กะมัง", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "หอรัตนไชย", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "หัวรอ", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ท่าวาสุกรี", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ไผ่ลิง", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ปากกราน", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ภูเขาทอง", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "สำเภาล่ม", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "สวนพริก", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "คลองตะเคียน", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "วัดตูม", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "หันตรา", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "ลุมพลี", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "บ้านใหม่", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "บ้านเกาะ", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "คลองสระบัว", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "เกาะเรียน", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "พระนครศรีอยุธยา", s: "บ้านป้อม", z: "13000" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "ท่าเรือ", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "จำปา", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "ท่าหลวง", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "บ้านร่อม", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "ศาลาลอย", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "วังแดง", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "โพธิ์เอน", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "ปากท่า", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "หนองขนาก", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "ท่าเรือ", s: "ท่าเจ้าสนุก", z: "13130" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "นครหลวง", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "ท่าช้าง", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "บ่อโพง", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "บ้านชุ้ง", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "ปากจั่น", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "บางระกำ", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "บางพระครู", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "แม่ลา", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "หนองปลิง", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "คลองสะแก", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "สามไถ", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "นครหลวง", s: "พระนอน", z: "13260" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บางไทร", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บางพลี", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "สนามชัย", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บ้านแป้ง", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "หน้าไม้", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บางยี่โท", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "แคออก", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "แคตก", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ช่างเหล็ก", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "กระแชง", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ช้างน้อย", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ห่อหมก", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ไผ่พระ", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "กกแก้วบูรพา", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ไม้ตรา", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บ้านม้า", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "บ้านเกาะ", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ราชคราม", z: "13290" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "ช้างใหญ่", z: "13290" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "เชียงรากน้อย", z: "13290" },
  { p: "พระนครศรีอยุธยา", d: "บางไทร", s: "โคกช้าง", z: "13190" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บางบาล", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "วัดยม", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "ไทรน้อย", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "สะพานไทย", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "มหาพราหมณ์", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "กบเจา", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บ้านคลัง", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "พระขาว", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "น้ำเต้า", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "ทางช้าง", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "วัดตะกู", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บางหลวง", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บางหลวงโดด", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บางหัก", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บางชะนี", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางบาล", s: "บ้านกุ่ม", z: "13250" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านเลน", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "เชียงรากน้อย", z: "13180" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านโพ", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านกรด", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บางกระสั้น", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "คลองจิก", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านหว้า", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "วัดยม", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บางประแดง", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "สามเรือน", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "เกาะเกิด", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านพลับ", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านแป้ง", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "คุ้งลาน", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "ตลิ่งชัน", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "บ้านสร้าง", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "บางปะอิน", s: "ขนอนหลวง", z: "13160" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บางปะหัน", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ขยาย", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บางเดื่อ", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "เสาธง", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ทางกลาง", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บางเพลิง", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "หันสัง", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บางนางร้า", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ตานิม", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ทับน้ำ", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บ้านม้า", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ขวัญเมือง", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บ้านลี่", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "โพธิ์สามต้น", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "พุทเลา", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "ตาลเอน", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "บางปะหัน", s: "บ้านขล้อ", z: "13220" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ผักไห่", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "อมฤต", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "บ้านแค", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ลาดน้ำเค็ม", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ตาลาน", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ท่าดินแดง", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ดอนลาน", z: "13280" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "นาคู", z: "13280" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "กุฎี", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ลำตะเคียน", z: "13280" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "โคกช้าง", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "จักราช", z: "13280" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "หนองน้ำใหญ่", z: "13280" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "ลาดชิด", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "หน้าโคก", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ผักไห่", s: "บ้านใหญ่", z: "13120" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "ภาชี", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "โคกม่วง", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "ระโสม", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "หนองน้ำใส", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "ดอนหญ้านาง", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "ไผ่ล้อม", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "กระจิว", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ภาชี", s: "พระแก้ว", z: "13140" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "ลาดบัวหลวง", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "หลักชัย", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "สามเมือง", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "พระยาบันลือ", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "สิงหนาท", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "คู้สลอด", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "ลาดบัวหลวง", s: "คลองพระยาบันลือ", z: "13230" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "ลำตาเสา", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "บ่อตาโล่", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "วังน้อย", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "ลำไทร", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "สนับทึบ", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "พยอม", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "หันตะเภา", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "วังจุฬา", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "ข้าวงาม", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "วังน้อย", s: "ชะแมบ", z: "13170" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "เสนา", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บ้านแพน", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "เจ้าเจ็ด", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "สามกอ", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บางนมโค", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "หัวเวียง", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "มารวิชัย", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บ้านโพธิ์", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "รางจรเข้", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บ้านกระทุ่ม", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บ้านแถว", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "ชายนา", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "สามตุ่ม", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "ลาดงา", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "ดอนทอง", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "บ้านหลวง", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "เสนา", s: "เจ้าเสด็จ", z: "13110" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "บางซ้าย", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "แก้วฟ้า", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "เต่าเล่า", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "ปลายกลัด", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "เทพมงคล", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "บางซ้าย", s: "วังพัฒนา", z: "13270" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "คานหาม", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "บ้านช้าง", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "สามบัณฑิต", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "บ้านหีบ", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "หนองไม้ซุง", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "อุทัย", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "เสนา", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "หนองน้ำส้ม", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "โพสาวหาญ", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "ธนู", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "อุทัย", s: "ข้าวเม่า", z: "13210" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "หัวไผ่", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "กะทุ่ม", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "มหาราช", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "น้ำเต้า", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "บางนา", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "โรงช้าง", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "เจ้าปลุก", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "พิตเพียน", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "บ้านนา", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "บ้านขวาง", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "ท่าตอ", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "มหาราช", s: "บ้านใหม่", z: "13150" },
  { p: "พระนครศรีอยุธยา", d: "บ้านแพรก", s: "บ้านแพรก", z: "13240" },
  { p: "พระนครศรีอยุธยา", d: "บ้านแพรก", s: "บ้านใหม่", z: "13240" },
  { p: "พระนครศรีอยุธยา", d: "บ้านแพรก", s: "สำพะเนียง", z: "13240" },
  { p: "พระนครศรีอยุธยา", d: "บ้านแพรก", s: "คลองน้อย", z: "13240" },
  { p: "พระนครศรีอยุธยา", d: "บ้านแพรก", s: "สองห้อง", z: "13240" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "ตลาดหลวง", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "บางแก้ว", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "ศาลาแดง", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "ป่างิ้ว", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "บ้านแห", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "ตลาดกรวด", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "มหาดไทย", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "บ้านอิฐ", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "หัวไผ่", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "จำปาหล่อ", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "โพสะ", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "บ้านรี", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "คลองวัว", z: "14000" },
  { p: "อ่างทอง", d: "เมืองอ่างทอง", s: "ย่านซื่อ", z: "14000" },
  { p: "อ่างทอง", d: "ไชโย", s: "จรเข้ร้อง", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ไชยภูมิ", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ชัยฤทธิ์", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "เทวราช", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ราชสถิตย์", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ไชโย", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "หลักฟ้า", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ชะไว", z: "14140" },
  { p: "อ่างทอง", d: "ไชโย", s: "ตรีณรงค์", z: "14140" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "บางปลากด", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "ป่าโมก", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "สายทอง", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "โรงช้าง", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "บางเสด็จ", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "นรสิงห์", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "เอกราช", z: "14130" },
  { p: "อ่างทอง", d: "ป่าโมก", s: "โผงเผง", z: "14130" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "อ่างแก้ว", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "อินทประมูล", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "บางพลับ", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "หนองแม่ไก่", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "รำมะสัก", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "บางระกำ", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "โพธิ์รังนก", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "องครักษ์", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "โคกพุทรา", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "บ่อแร่", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "ทางพระ", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "สามง่าม", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "บางเจ้าฉ่า", z: "14120" },
  { p: "อ่างทอง", d: "โพธิ์ทอง", s: "คำหยาด", z: "14120" },
  { p: "อ่างทอง", d: "แสวงหา", s: "แสวงหา", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "ศรีพราน", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "บ้านพราน", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "วังน้ำเย็น", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "สีบัวทอง", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "ห้วยไผ่", z: "14150" },
  { p: "อ่างทอง", d: "แสวงหา", s: "จำลอง", z: "14150" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ศาลเจ้าโรงทอง", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ไผ่ดำพัฒนา", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "สาวร้องไห้", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ท่าช้าง", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ยี่ล้น", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "บางจัก", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ห้วยคันแหลน", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "คลองขนาก", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ไผ่วง", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "สี่ร้อย", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ม่วงเตี้ย", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "หัวตะพาน", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "หลักแก้ว", z: "14110" },
  { p: "อ่างทอง", d: "วิเศษชัยชาญ", s: "ตลาดใหม่", z: "14110" },
  { p: "อ่างทอง", d: "สามโก้", s: "สามโก้", z: "14160" },
  { p: "อ่างทอง", d: "สามโก้", s: "ราษฎรพัฒนา", z: "14160" },
  { p: "อ่างทอง", d: "สามโก้", s: "อบทม", z: "14160" },
  { p: "อ่างทอง", d: "สามโก้", s: "โพธิ์ม่วงพันธ์", z: "14160" },
  { p: "อ่างทอง", d: "สามโก้", s: "มงคลธรรมนิมิต", z: "14160" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ทะเลชุบศร", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ท่าหิน", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "กกโก", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "โก่งธนู", z: "13240" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "เขาพระงาม", z: "15160" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "เขาสามยอด", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "โคกลำพาน", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "โคกตูม", z: "15210" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "งิ้วราย", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ดอนโพธิ์", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ตะลุง", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ท่าแค", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ท่าศาลา", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "นิคมสร้างตนเอง", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "บางขันหมาก", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "บ้านข่อย", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ท้ายตลาด", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ป่าตาล", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "พรหมมาสตร์", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "โพธิ์เก้าต้น", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "โพธิ์ตรุ", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "สี่คลอง", z: "15000" },
  { p: "ลพบุรี", d: "เมืองลพบุรี", s: "ถนนใหญ่", z: "15000" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "พัฒนานิคม", z: "15140" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "ช่องสาริกา", z: "15220" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "มะนาวหวาน", z: "15140" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "ดีลัง", z: "15220" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "โคกสลุง", z: "15140" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "ชอนน้อย", z: "15140" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "หนองบัว", z: "15140" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "ห้วยขุนราม", z: "18220" },
  { p: "ลพบุรี", d: "พัฒนานิคม", s: "น้ำสุด", z: "15140" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "โคกสำโรง", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "เกาะแก้ว", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "ถลุงเหล็ก", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "หลุมข้าว", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "ห้วยโป่ง", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "คลองเกตุ", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "สะแกราบ", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "เพนียด", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "วังเพลิง", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "ดงมะรุม", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "วังขอนขว้าง", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "วังจั่น", z: "15120" },
  { p: "ลพบุรี", d: "โคกสำโรง", s: "หนองแขม", z: "15120" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ลำนารายณ์", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ชัยนารายณ์", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ศิลาทิพย์", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ห้วยหิน", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ม่วงค่อม", z: "15230" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "บัวชุม", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ท่าดินดำ", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "มะกอกหวาน", z: "15230" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ซับตะเคียน", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "นาโสม", z: "15190" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "หนองยายโต๊ะ", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "เกาะรัง", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ท่ามะนาว", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "นิคมลำนารายณ์", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "ชัยบาดาล", z: "15230" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "บ้านใหม่สามัคคี", z: "15130" },
  { p: "ลพบุรี", d: "ชัยบาดาล", s: "เขาแหลม", z: "15130" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "ท่าวุ้ง", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "บางคู้", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "โพลาดแก้ว", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "บางลี่", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "บางงา", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "โคกสลุด", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "เขาสมอคอน", z: "15180" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "หัวสำโรง", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "ลาดสาลี่", z: "15150" },
  { p: "ลพบุรี", d: "ท่าวุ้ง", s: "มุจลินท์", z: "15150" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "ไผ่ใหญ่", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บ้านทราย", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บ้านกล้วย", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "ดงพลับ", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บ้านชี", z: "15180" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "พุคา", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "หินปัก", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บางพึ่ง", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "หนองทรายขาว", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บางกะพี้", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "หนองเต่า", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "โพนทอง", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "บางขาม", z: "15180" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "ดอนดึง", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "ชอนม่วง", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "หนองกระเบียน", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "สายห้วยแก้ว", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "มหาสอน", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "หนองเมือง", z: "15110" },
  { p: "ลพบุรี", d: "บ้านหมี่", s: "สนามแจง", z: "15110" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "ท่าหลวง", z: "15230" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "แก่งผักกูด", z: "15230" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "ซับจำปา", z: "15230" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "หนองผักแว่น", z: "15230" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "ทะเลวังวัด", z: "15230" },
  { p: "ลพบุรี", d: "ท่าหลวง", s: "หัวลำ", z: "15230" },
  { p: "ลพบุรี", d: "สระโบสถ์", s: "สระโบสถ์", z: "15240" },
  { p: "ลพบุรี", d: "สระโบสถ์", s: "มหาโพธิ", z: "15240" },
  { p: "ลพบุรี", d: "สระโบสถ์", s: "ทุ่งท่าช้าง", z: "15240" },
  { p: "ลพบุรี", d: "สระโบสถ์", s: "ห้วยใหญ่", z: "15240" },
  { p: "ลพบุรี", d: "สระโบสถ์", s: "นิยมชัย", z: "15240" },
  { p: "ลพบุรี", d: "โคกเจริญ", s: "โคกเจริญ", z: "15250" },
  { p: "ลพบุรี", d: "โคกเจริญ", s: "ยางราก", z: "15250" },
  { p: "ลพบุรี", d: "โคกเจริญ", s: "หนองมะค่า", z: "15250" },
  { p: "ลพบุรี", d: "โคกเจริญ", s: "วังทอง", z: "15250" },
  { p: "ลพบุรี", d: "โคกเจริญ", s: "โคกแสมสาร", z: "15250" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "ลำสนธิ", z: "15190" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "ซับสมบูรณ์", z: "15190" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "หนองรี", z: "15190" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "กุดตาเพชร", z: "15190" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "เขารวก", z: "15190" },
  { p: "ลพบุรี", d: "ลำสนธิ", s: "เขาน้อย", z: "15130" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "หนองม่วง", z: "15170" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "บ่อทอง", z: "15170" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "ดงดินแดง", z: "15170" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "ชอนสมบูรณ์", z: "15170" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "ยางโทน", z: "15170" },
  { p: "ลพบุรี", d: "หนองม่วง", s: "ชอนสารเดช", z: "15170" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "บางปลาสร้อย", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "มะขามหย่ง", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "บ้านโขน", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "แสนสุข", z: "20130" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "บ้านสวน", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "หนองรี", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "นาป่า", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "หนองข้างคอก", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "ดอนหัวฬ่อ", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "หนองไม้แดง", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "บางทราย", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "คลองตำหรุ", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "เหมือง", z: "20130" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "บ้านปึก", z: "20130" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "ห้วยกะปิ", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "เสม็ด", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "อ่างศิลา", z: "20000" },
  { p: "ชลบุรี", d: "เมืองชลบุรี", s: "สำนักบก", z: "20000" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "บ้านบึง", z: "20170" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "คลองกิ่ว", z: "20220" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "มาบไผ่", z: "20170" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "หนองซ้ำซาก", z: "20170" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "หนองบอนแดง", z: "20170" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "หนองชาก", z: "20170" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "หนองอิรุณ", z: "20220" },
  { p: "ชลบุรี", d: "บ้านบึง", s: "หนองไผ่แก้ว", z: "20220" },
  { p: "ชลบุรี", d: "หนองใหญ่", s: "หนองใหญ่", z: "20190" },
  { p: "ชลบุรี", d: "หนองใหญ่", s: "คลองพลู", z: "20190" },
  { p: "ชลบุรี", d: "หนองใหญ่", s: "หนองเสือช้าง", z: "20190" },
  { p: "ชลบุรี", d: "หนองใหญ่", s: "ห้างสูง", z: "20190" },
  { p: "ชลบุรี", d: "หนองใหญ่", s: "เขาซก", z: "20190" },
  { p: "ชลบุรี", d: "บางละมุง", s: "บางละมุง", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "หนองปรือ", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "หนองปลาไหล", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "โป่ง", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "เขาไม้แก้ว", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "ห้วยใหญ่", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "ตะเคียนเตี้ย", z: "20150" },
  { p: "ชลบุรี", d: "บางละมุง", s: "นาเกลือ", z: "20150" },
  { p: "ชลบุรี", d: "พานทอง", s: "พานทอง", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "หนองตำลึง", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "มาบโป่ง", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "หนองกะขะ", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "หนองหงษ์", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "โคกขี้หนอน", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "บ้านเก่า", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "หน้าประดู่", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "บางนาง", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "เกาะลอย", z: "20160" },
  { p: "ชลบุรี", d: "พานทอง", s: "บางหัก", z: "20160" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "พนัสนิคม", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หน้าพระธาตุ", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "วัดหลวง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "นาเริก", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หมอนนาง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "สระสี่เหลี่ยม", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "วัดโบสถ์", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "กุฎโง้ง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หัวถนน", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "ท่าข้าม", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หนองปรือ", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หนองขยาด", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "ทุ่งขวาง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "หนองเหียง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "นาวังหิน", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "บ้านช้าง", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "โคกเพลาะ", z: "20140" },
  { p: "ชลบุรี", d: "พนัสนิคม", s: "ไร่หลักทอง", z: "20140" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "ศรีราชา", z: "20110" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "สุรศักดิ์", z: "20110" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "ทุ่งสุขลา", z: "20230" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "บึง", z: "20230" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "หนองขาม", z: "20110" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "เขาคันทรง", z: "20110" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "บางพระ", z: "20110" },
  { p: "ชลบุรี", d: "ศรีราชา", s: "บ่อวิน", z: "20230" },
  { p: "ชลบุรี", d: "เกาะสีชัง", s: "ท่าเทววงษ์", z: "20120" },
  { p: "ชลบุรี", d: "สัตหีบ", s: "สัตหีบ", z: "20180" },
  { p: "ชลบุรี", d: "สัตหีบ", s: "นาจอมเทียน", z: "20250" },
  { p: "ชลบุรี", d: "สัตหีบ", s: "พลูตาหลวง", z: "20180" },
  { p: "ชลบุรี", d: "สัตหีบ", s: "บางเสร่", z: "20250" },
  { p: "ชลบุรี", d: "สัตหีบ", s: "แสมสาร", z: "20180" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "บ่อทอง", z: "20270" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "วัดสุวรรณ", z: "20270" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "บ่อกวางทอง", z: "20270" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "ธาตุทอง", z: "20270" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "เกษตรสุวรรณ", z: "20270" },
  { p: "ชลบุรี", d: "บ่อทอง", s: "พลวงทอง", z: "20270" },
  { p: "ชลบุรี", d: "เกาะจันทร์", s: "เกาะจันทร์", z: "20240" },
  { p: "ชลบุรี", d: "เกาะจันทร์", s: "ท่าบุญมี", z: "20240" }
];
